import React, { useMemo, useEffect } from "react";
import { useGLTF, Clone } from '@react-three/drei'

export default function BaseModel(props) {
  const model = useGLTF('/cozyPlace.glb')

  // 遍历模型的所有子对象，为每个mesh设置阴影
  useEffect(() => {
    model.scene.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true
        child.receiveShadow = true
      }
    })
  }, [model.scene])

  return <primitive
    object={model.scene}
    position={props.position}
    rotation={props.rotation}
    scale={props.scale}
  />
}
